// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".snapshot-table-column-header[data-v-1045b939]{background-color:#d2d3d5;position:relative;margin-bottom:1.5rem;padding:0}.snapshot-table-column-header .snapshot-table-column-header-title[data-v-1045b939]{padding-left:12px;padding-top:3px;padding-bottom:3px;font-weight:700;font-size:1em;text-transform:uppercase;color:#000;display:table-cell;vertical-align:middle}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
